export default __webpack_public_path__ + "static/media/slide-1.84aef399.jpg";